import { DataTableV2, Field, Text, TextField } from "components/commons";
import styles from "../order-summary.module.scss";
import locale from "localization";
import useDataTable from "hooks/useDataTable";
import { mapDataToOrderItems } from "./mapper";
import { fuelColumns } from "./columns";
import { useFormContext } from "contexts/form-context";
import { useEffect } from "react";
import { useDynamicFieldsForm } from "hooks";
import Validation from "utils/validation.utils";

const OrderSummaryItemOrders = ({ orderSummary }) => {
  const {
    fields: rootFields,
    modifyField: modifyRootField,
    setSubFormsSubmittableState,
    initialState,
  } = useFormContext();

  const { fieldsAsRows, modifyField, addRows, modifyForm, clearRows } = useDynamicFieldsForm({
    rowId: "orderItemId",
    onChangeIsSubmittable: ({ isFormSubmittable, rowsValues }) => {
      setSubFormsSubmittableState((f) => ({ ...f, order: isFormSubmittable }));
      modifyRootField("orderItems", {
        value: rowsValues,
      });
    },
  });

  useEffect(() => {
    const orderItems = orderSummary?.order?.orderItems || [];

    if (orderItems.length === 0) {
      modifyRootField("orderItems", { value: [] });
      clearRows?.();
      return;
    }

    const rows = orderItems.map((item) => [
      { name: "orderItemId", value: item.orderItemId },
      {
        name: "amount",
        value: item.amount ?? "",
        label: locale.amount,
        required: true,
        min: 0.0,
        max: 9999999999999.99,
        placeholder: "0.00",
        validations: [
          Validation.required({ noMessage: true }),
          Validation.min(0.001, {
            customMessage: locale.minimumAmount,
          }),
        ],
      },
      {
        name: "inventoryLevelCm",
        value: item.inventoryLevelCm ?? "",
        label: locale.inventoryLevelCm,
        required: false,
      },
      {
        name: "inventoryLevelLiter",
        value: item.inventoryLevelLiter ?? "",
        label: locale.inventoryLevelLiter,
        required: false,
      },
      {
        name: "isInventoryFromTotalizer",
        value: item.isInventoryFromTotalizer ?? false,
        label: locale.isInventoryFromTotalizer,
        required: false,
      },
      {
        name: "volume",
        value: item.volume ?? "",
        label: locale.volume,
        required: false,
      },
      {
        name: "productCode",
        value: item.productCode ?? "",
        label: locale.productCode,
        required: false,
      },
    ]);

    addRows(rows);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialState?.orderItems?.value]);

  const { table } = useDataTable({
    value: orderSummary.order?.orderItems || [],
    filter: { initialState: {}, mapper: (param) => param },
    table: {
      key: "order",
      mapper: (orderItem) =>
        mapDataToOrderItems({
          orderItem,
          fieldsAsRows,
          modifyField,
          modifyForm,
        }),
      columns: fuelColumns,
    },
  });

  return (
    <>
      <Text strong color={"black"} className={styles.sectionTitle}>
        {locale.itemOrder}
      </Text>

      <DataTableV2
        {...table}
        size="small"
        hidePagination
        hideNoSearchResultRender
        tableVersion="v2"
        striped={true}
        className={styles.tableContainer}
      />

      <Field
        {...rootFields.remarksHo}
        label={locale.remarksHo}
        labelPosition={"left-start-aligned"}
        labelClassName={styles.fieldLabel}
      >
        <div className={styles.remarks}>
          <TextField multiline {...rootFields?.remarksHo} onChange={modifyRootField} />
        </div>
      </Field>
    </>
  );
};

export default OrderSummaryItemOrders;
